<template>
    <div class="container auto homePage2">
        <div class="clearfix row">
            <div class="header_title wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                <p class="subtitle">SOLUTION</p>
                <p class="title">解决方案</p>
                <p class="tit_cont">
                    专注云打印解决方案，多年互联网应用开发经验，整合时下最新的云打印技术
                    <br />以产品设计为核心驱动力，协同专业的项目能力，为客户提供针对性的解决方案，帮助客户解决问题
                </p>
            </div>
        </div>
        <el-row style="margin: 30px 150px;">
            <el-col :span="5" v-for="(item,index) in list" :key="item.title">
                <img :src="'/static/img/a' + index + '.png'" />
                <div class="p15">{{ item.title }}</div>
                <div class="content">{{ item.content }}</div>
            </el-col>
        </el-row>
    </div>
</template>


<script>
export default {
    data() {
        return {
            list: [
                {
                    title: '餐饮外卖',
                    content: '订单自动打印，省时、省力、更省心！'
                },
                {
                    title: '快递面单',
                    content: '让快递方便快捷更高效'
                },
                {
                    title: '酒店',
                    content: '一键订房，快速打印小票'
                },
                {
                    title: '加油站',
                    content: '扫码付款，自动打印发票'
                },
                {
                    title: '微商城',
                    content: '订单自动打印'
                },
                {
                    title: '无人便利店',
                    content: '智慧新零售，门店解决方案'
                },
                {
                    title: '票务',
                    content: '轻松打印门票、收据等'
                },
                {
                    title: '网络医院',
                    content: '远程打印药方票据'
                },
                {
                    title: '教育',
                    content: '文件、错题、答案打印'
                },
                {
                    title: '网店',
                    content: '节省人手，提高效率'
                }
            ]
        }
    }

}
</script>


<style scoped>
.content {
    line-height: 20px;
    color: #999;
    font-size: 12px;
}

.homePage2 {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 0px;
}

.p15 {
    padding-top: 15px;
}
</style>

<style>
.homePage2 .el-col.el-col-5 {
    width: 20%;
    padding-bottom: 40px;
}

.homePage2 .el-row {
    display: flex;
    flex-wrap: wrap;
    margin: 25px;
}

.homePage2 .el-col.el-col-5 img {
    width: 100px;
    margin: 0 auto;
    height: auto;
}
</style>


// WEBPACK FOOTER //
// homePage2.vue?f38c0314